import { render, staticRenderFns } from "./LandListTable.vue?vue&type=template&id=4cafd1fc&scoped=true&"
import script from "./LandListTable.vue?vue&type=script&lang=js&"
export * from "./LandListTable.vue?vue&type=script&lang=js&"
import style0 from "./LandListTable.vue?vue&type=style&index=0&id=4cafd1fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cafd1fc",
  null
  
)

export default component.exports